import { render, staticRenderFns } from "./AddRMWizard.vue?vue&type=template&id=1b4efa67&scoped=true&"
import script from "./AddRMWizard.vue?vue&type=script&lang=js&"
export * from "./AddRMWizard.vue?vue&type=script&lang=js&"
import style0 from "./AddRMWizard.vue?vue&type=style&index=0&id=1b4efa67&lang=scss&"
import style1 from "./AddRMWizard.vue?vue&type=style&index=1&id=1b4efa67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4efa67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b4efa67')) {
      api.createRecord('1b4efa67', component.options)
    } else {
      api.reload('1b4efa67', component.options)
    }
    module.hot.accept("./AddRMWizard.vue?vue&type=template&id=1b4efa67&scoped=true&", function () {
      api.rerender('1b4efa67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rawmaterials/AddProduct/AddRMWizard.vue"
export default component.exports